import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
/**
 * DatePickerField
 *
 * A controlled MUI DateTimePicker.
 *
 * Props:
 *   value         {string|number|null} - ISO string or unix timestamp (controlled)
 *   onChange      {Function}           - called with ISO string or unix timestamp (or null if cleared)
 *   label         {string}             - field label (default: "Select Date & Time")
 *   minDateTime   {string|null}        - optional min datetime as ISO string
 *   maxDateTime   {string|null}        - optional max datetime as ISO string
 *   disabled      {boolean}
 *   unixTime      {boolean}            - if true, value/onChange use unix timestamps; otherwise ISO strings
 *   disableFuture {boolean}            - if true, restricts selection to now or earlier
 */
export default function DatePickerField({
  value = null,
  onChange,
  label = "Select Date & Time",
  minDateTime = null,
  maxDateTime = null,
  disabled = false,
  unixTime = false,
  noLabel = false,
  disableFuture = false,
}) {
  const dayjsValue = value
    ? unixTime
      ? dayjs.unix(value)
      : dayjs(value)
    : null;
  const handleChange = (newDayjsValue) => {
    if (!newDayjsValue || !newDayjsValue.isValid()) {
      onChange?.(null);
      return;
    }
    onChange?.(unixTime ? newDayjsValue.unix() : newDayjsValue.format("YYYY-MM-DDTHH:mm:ss"));
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        className="date-input-field"
        label={noLabel ? "" : label}
        value={dayjsValue}
        onChange={handleChange}
        disabled={disabled}
        format="DD/MM/YYYY HH:mm"
        disableFuture={disableFuture}
        minDateTime={minDateTime ? dayjs(minDateTime) : undefined}
        maxDateTime={maxDateTime ? dayjs(maxDateTime) : undefined}
        slotProps={{
          textField: {
            fullWidth: true,
            variant: "outlined",
          },
        }}
      />
    </LocalizationProvider>
  );
}